import styled from 'styled-components';

export const Load = styled.div`
  padding-top: 8rem;
`;
